const { remote } = window.require ? window.require('electron') : ''
const { Menu } = remote || ''
const isDevelopment = process.env.NODE_ENV !== 'production'
let platform = remote?.getGlobal('sharedObject')?.platform
export default {
    watch: {
        '$store.state.language': {
            deep: true,
            handler: function() {
                this.buildMenu();
            }
        },
    },
    methods: {
        buildMenu() {
            if(!remote) {
                console.log('electron is undefined');
                return
            }
            const language = this.$store.state.language || this.$sg.ls.get('language')
            let template = [{
                label: this.$t('menus.查看'),
                submenu: [
                    {
                        label: this.$t('menus.刷新'),
                        accelerator: 'F5',
                        role: 'reload',
                    },
                    {
                        label: this.$t('menus.强制刷新'),
                        accelerator: 'CmdOrCtrl+F5',
                        role: 'forcereload',
                    },
                    {
                        label: this.$t('menus.强制刷新'),
                        accelerator: 'Cmd+shift+r',
                        role: 'forcereload',
                    },
                    {
                        label: this.$t('menus.开发者模式'),
                        accelerator: 'F12',
                        role: 'toggledevtools',
                    },
                ],
            }]
            if (platform === 'darwin' || isDevelopment) {
                Menu.setApplicationMenu(Menu.buildFromTemplate(template))
            } else {
                Menu.setApplicationMenu(Menu.buildFromTemplate([]))
            }
        }
    }
}